<template lang="pug">
 .component-packet-vehicle-category
   .card( v-if="$is('listing')")
     .inner-content
       card-n(:showBullets="true", :showAction="true", :columns="3")
         div(slot="actionBullets")
           dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
            packet-vehicle-category-button(:item="item", @itemUpdated="$emit('itemUpdated')")
         .field-value(slot="n1") PVC{{item.id}}
         .label(slot="n2") Packet
         .field-value(slot="n2") id: {{item.packet.id}}
         .field-value(slot="n2") name: {{item.packet.name}}
         .label(slot="n3") Category
         .field-value(slot="n3") id: {{item.category.id}}
         .field-value(slot="n3") name: {{item.category.name}}
</template>

<script>
import PacketVehicleCategoryButton from "../structure/ui/actions/PacketVehicleCategoryButton";
import CardN from "../structure/CardN";
import Dropdown from "../structure/foundation/Dropdown";
export default {
  name: "PacketVehicleCategory",
  components: {PacketVehicleCategoryButton, CardN, Dropdown},
  data() {
    return {}
  },
  created() {
  },
  methods: {},
  computed: {},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketVehicleCategory.vue?0ef3316a